var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterviewbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46027 5.07962L8.00027 6.53962L6.53027 5.07962L8.00027 3.60962L9.46027 5.06962V5.07962Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00035 6.70993L6.36035 5.06993L8.00035 3.42993L9.64035 5.06993L8.00035 6.70993ZM6.71035 5.06993L8.00035 6.35993L9.29035 5.06993L8.00035 3.77993L6.71035 5.06993Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46027 8.00956L8.00027 9.46956L6.53027 8.00956L8.00027 6.54956L9.46027 8.00956Z",
    fill: "#FFB94D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00035 9.63962L6.36035 7.99962L8.00035 6.35962L9.64035 7.99962L8.00035 9.63962ZM6.71035 7.99962L8.00035 9.28962L9.29035 7.99962L8.00035 6.70962L6.71035 7.99962Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 6.53983L6.54031 7.99983L5.07031 6.53983L6.54031 5.07983L8.00031 6.53983Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54039 8.17966L4.90039 6.53966L6.54039 4.89966L8.18039 6.53966L6.54039 8.17966ZM5.25039 6.53966L6.54039 7.82966L7.83039 6.53966L6.54039 5.24966L5.25039 6.53966Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 6.53983L9.47 7.99983L8 6.53983L9.47 5.07983L10.93 6.53983Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47008 8.17966L7.83008 6.53966L9.47008 4.89966L11.1101 6.53966L9.47008 8.17966ZM8.18008 6.53966L9.47008 7.82966L10.7601 6.53966L9.47008 5.24966L8.18008 6.53966Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46027 10.9295L8.00027 12.3895L6.53027 10.9295L8.00027 9.46948L9.46027 10.9295Z",
    fill: "#61DDE1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00035 12.5698L6.36035 10.9298L8.00035 9.28979L9.64035 10.9298L8.00035 12.5698ZM6.71035 10.9298L8.00035 12.2198L9.29035 10.9298L8.00035 9.63979L6.71035 10.9298Z",
    fill: "#666666"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 9.46952L6.54031 10.9295L5.07031 9.46952L6.54031 8.00952L8.00031 9.46952Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54039 11.1098L4.90039 9.46983L6.54039 7.82983L8.18039 9.46983L6.54039 11.1098ZM5.25039 9.46983L6.54039 10.7598L7.83039 9.46983L6.54039 8.17983L5.25039 9.46983Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52961 8.00956L5.06961 9.46956L3.59961 8.00956L5.06961 6.54956L6.52961 8.00956Z",
    fill: "#FFB94D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06969 9.63962L3.42969 7.99962L5.06969 6.35962L6.70969 7.99962L5.06969 9.63962ZM3.77969 7.99962L5.06969 9.28962L6.35969 7.99962L5.06969 6.70962L3.77969 7.99962Z",
    fill: "#666666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52961 10.9295L5.06961 12.3895L3.59961 10.9295L5.06961 9.46948L6.52961 10.9295Z",
    fill: "#61DDE1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06969 12.5698L3.42969 10.9298L5.06969 9.28979L6.70969 10.9298L5.06969 12.5698ZM3.77969 10.9298L5.06969 12.2198L6.35969 10.9298L5.06969 9.63979L3.77969 10.9298Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06965 9.46952L3.60965 10.9295L2.13965 9.46952L3.60965 8.00952L5.06965 9.46952Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60973 11.1098L1.96973 9.46983L3.60973 7.82983L5.24973 9.46983L3.60973 11.1098ZM2.31973 9.46983L3.60973 10.7598L4.89973 9.46983L3.60973 8.17983L2.31973 9.46983Z",
    fill: "#666666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59992 10.9397L2.13992 12.3997L0.669922 10.9397L2.13992 9.47974L3.59992 10.9397Z",
    fill: "#61DDE1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14 12.5698L0.5 10.9298L2.14 9.28979L3.78 10.9298L2.14 12.5698ZM0.85 10.9298L2.14 12.2198L3.43 10.9298L2.14 9.63979L0.85 10.9298Z",
    fill: "#666666"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 9.46952L9.47 10.9295L8 9.46952L9.47 8.00952L10.93 9.46952Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47008 11.1098L7.83008 9.46983L9.47008 7.82983L11.1101 9.46983L9.47008 11.1098ZM8.18008 9.46983L9.47008 10.7598L10.7601 9.46983L9.47008 8.17983L8.18008 9.46983Z",
    fill: "#666666"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3997 8.00956L10.9397 9.46956L9.46973 8.00956L10.9397 6.54956L12.3997 8.00956Z",
    fill: "#FFB94D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 9.63962L9.29004 7.99962L10.93 6.35962L12.57 7.99962L10.93 9.63962ZM9.64004 7.99962L10.93 9.28962L12.22 7.99962L10.93 6.70962L9.64004 7.99962Z",
    fill: "#666666"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3997 10.9295L10.9397 12.3895L9.46973 10.9295L10.9397 9.46948L12.3997 10.9295Z",
    fill: "#61DDE1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 12.5698L9.29004 10.9298L10.93 9.28979L12.57 10.9298L10.93 12.5698ZM9.64004 10.9298L10.93 12.2198L12.22 10.9298L10.93 9.63979L9.64004 10.9298Z",
    fill: "#666666"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8597 9.46952L12.3997 10.9295L10.9297 9.46952L12.3997 8.00952L13.8597 9.46952Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3998 11.1098L10.7598 9.46983L12.3998 7.82983L14.0398 9.46983L12.3998 11.1098ZM11.1098 9.46983L12.3998 10.7598L13.6898 9.46983L12.3998 8.17983L11.1098 9.46983Z",
    fill: "#666666"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3304 10.9397L13.8704 12.3997L12.4004 10.9397L13.8704 9.47974L15.3304 10.9397Z",
    fill: "#61DDE1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8597 12.5698L12.2197 10.9298L13.8597 9.28979L15.4997 10.9298L13.8597 12.5698ZM12.5697 10.9298L13.8597 12.2198L15.1497 10.9298L13.8597 9.63979L12.5697 10.9298Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewbit);
export default __webpack_public_path__ + "static/media/interviewbit.74cdb4709c30f435bf75cd33f46e1164.svg";
export { ForwardRef as ReactComponent };